<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-2"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <b-form-group
                label-cols="2"
                label-cols-lg="2"
                label="IMPORT WEB :"
                label-for="input-lg"
              >
                <b-input-group>
                  <b-form-input
                    id="input-lg"
                    v-model="inputUrl"
                    placeholder="URL IMPORT"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="getData"
                    >
                      <span class="mr-25 align-middle">{{
                        $t('GET_FROM_URL')
                      }}</span>
                      <feather-icon
                        icon="GlobeIcon"
                        size="12"
                      />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                @click="clearData"
              >
                <feather-icon
                  icon="RefreshIcon"
                  class="mr-50"
                />
                <span class="align-middle">{{ $t('Reset') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <div
      v-if="valueMember != 0"
      class="mb-2"
    >
      <label>{{ $t('Member') }} {{ valueMember }} / {{ maxMember }} ({{
        nameMember
      }})</label>
      <b-progress :max="maxMember">
        <b-progress-bar :value="valueMember">
          <strong>{{ valueMember }} / {{ maxMember }}</strong>
        </b-progress-bar>
      </b-progress>
    </div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t('Data') }} {{ queriedItems }} {{ $t('List') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="pageSize"
              />
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="b-col-custom"
            >
              <div class="d-flex align-items-center justify-content-end">
                <!-- <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search')+'...'"
                /> -->
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  class="d-flex"
                  @click="selectAllRows"
                >
                  <feather-icon icon="ListIcon" />
                  <span class="mr-25 align-middle">{{ $t('SELECT_ALL') }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  class="d-flex ml-2"
                  @click="clearSelected"
                >
                  <feather-icon icon="XIcon" />
                  <span class="mr-25 align-middle">{{
                    $t('CLEAR_SELECTED')
                  }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="d-flex ml-2"
                  @click="importData"
                >
                  <feather-icon icon="PlusIcon" />
                  <span class="mr-25 align-middle">{{ $t('IMPORT') }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="d-flex ml-2"
                  @click="importAllProduct"
                >
                  <feather-icon icon="PlusIcon" />
                  <span class="mr-25 align-middle">{{ $t('IMPORT_ALL') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="selectableTable"
          striped
          responsive
          class="position-relative"
          :items="respData"
          :select-mode="selectMode"
          :fields="tableColumns"
          :per-page="perPage"
          :current-page="currentPage"
          primary-key="products_id"
          show-empty
          :empty-text="$t('No matching records found')"
          selectable
          style="height: 60vh;"
          @row-selected="onRowSelected"
        >
          <!-- Example scoped slot for select state illustrative purposes -->
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <template #cell(fullName)="data">
            <b-card-text>{{ data.item.members_name }}
              {{ data.item.members_lastname }}</b-card-text>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="
                d-flex
                align-items-center
                justify-content-center justify-content-sm-start
              "
            >
              <span
                class="text-muted"
              >{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t('of') }} {{ queriedItems }}</span>
            </b-col>
          </b-row>
        </div>
        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="queriedItems"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="nextPage"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      :title="$t('IMPORT_DATA')"
      :ok-title="$t('IMPORT')"
      cancel-variant="outline-secondary"
      @ok="importData"
    />
  </div>
</template>

<script>
import {
  BCardText,
  BCard,
  BRow,
  BCol,
  BPagination,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormGroup,
  BButton,
  BTable,
  BOverlay,
  BModal,
  VBModal,
  BProgress,
  BProgressBar,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import { useToast } from 'vue-toastification/composition'
import perPageOptions from '@/perPageOptions'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/eCommerce/member'
import axios from 'axios'

// const https = require('https')

const STORE_MODULE_NAME = 'member'

export default {
  components: {
    BCardText,
    BCard,
    BRow,
    BCol,
    BPagination,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BButton,
    // Sidebar,
    BTable,
    BOverlay,
    BModal,
    BProgress,
    BProgressBar,
    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      avatarText,
      inputUrl:
        process.env.NODE_ENV === 'production'
          ? ''
          : 'https://api.gooapp.me/gooweb/api_startapp.php?site_id=35119&cmd=getmembers&token=432wfasfasdyuiytuihhfs87xvcvbh',
      respData: [],
      perPageOptions,
      show: false,
      queriedItems: 0,
      currentPage: 1,
      perPage: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 50,
      totalRows: 1,
      selectMode: 'multi',
      selected: [],
      nameMember: '',
      valueMember: 0,
      maxMember: 0,
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'selected', label: this.$t('SELECTED'), sortable: false },
        { key: 'members_tel', label: this.$t('PhoneNumber'), sortable: false },
        { key: 'members_username', label: this.$t('Username'), sortable: true },
        { key: 'members_passwd', label: this.$t('Password'), sortable: false },
        { key: 'members_email', label: this.$t('Email'), sortable: false },
        {
          key: 'fullName',
          label: this.$t('FullName'),
          sortable: true,
        },
        // { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    wsClient() {
      return store.state.websockets.wsClient[STORE_MODULE_NAME]
    },
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) {
      store.registerModule(STORE_MODULE_NAME, storeModule)
    }
    const userData = JSON.parse(localStorage.getItem('userData'))
    const applicationId = localStorage.getItem('applicationId')
    // WebSocket Connect
    const pathname = `/Members?type=${userData.userType}&userId=${userData.userId}&applicationId=${applicationId}`
    const params = {
      pathname,
      page: STORE_MODULE_NAME,
    }
    store.dispatch('websockets/connect', params)
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) {
      store.unregisterModule(STORE_MODULE_NAME)
    }
    store.dispatch('websockets/disconnect', STORE_MODULE_NAME)
  },
  beforeMount() {
    // WebSocket
    if (this.wsClient) {
      // ถ้าเกิดเชื่อมไม่ได้ จะเข้า onErrorก่อน หลังจากนั้นจะทำการ onClose เอง
      this.wsClient.onerror = err => {
        console.log('onError')
        console.log(err)
      }
      this.wsClient.onclose = err => {
        console.log('onClose')
        console.log(err)
      }
      this.wsClient.onmessage = msg => {
        const SocketMessage = JSON.parse(msg.data)
        //
        if (SocketMessage.data.send) {
          if (SocketMessage.data.send.data.message === 'IMPORT_MEMBER') {
            this.show = true
            this.nameMember = SocketMessage.data.send.data.data.nameMember
            this.valueMember = SocketMessage.data.send.data.data.currentMember
            this.maxMember = SocketMessage.data.send.data.data.maxMember
            if (this.valueMember === this.maxMember) {
              this.show = false
            }
          }
        }

        // this.adminOnline = SocketMessage.data.web.admin.length
        // this.rootOnline = SocketMessage.data.web.root.length
      }
    }
  },
  methods: {
    importAllProduct() {
      this.$bvModal
        .msgBoxConfirm(
          `${this.$t('Do you want to import all product')} ${
            this.respData.length
          } ${this.$t('List')}?`,
          {
            title: this.$t('Please Confirm'),
            cancelVariant: 'outline-secondary',
            okVariant: 'success',
            okTitle: this.$t('Yes'),
            cancelTitle: this.$t('No'),
            centered: true,
          },
        )
        .then(value => {
          if (value === true) {
            if (this.respData.length > 0) {
              const obj = {
                dataSelected: this.respData,
              }
              this.show = true
              store
                .dispatch(`${STORE_MODULE_NAME}/import`, obj)
                .then(() => {
                  this.show = false

                  this.showToast(
                    'warning',
                    'top-right',
                    `${this.$t('IMPORT_DATA')}! ${
                      this.respData.length
                    } ${this.$t('List')}`,
                    'PlusIcon',
                    this.$t('IMPORT_DATA'),
                  )
                })
                .catch(error => {
                  this.show = false

                  this.$toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                      title: this.$t('Error'),
                      icon: 'ErrorIcon',
                      variant: 'danger',
                      text: this.$t(error.response.data.message),
                    },
                  })
                })
            }
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    importData() {
      this.$bvModal
        .msgBoxConfirm(
          `${this.$t('Do you want to import all product')} ${
            this.selected.length
          } ${this.$t('List')}?`,
          {
            title: this.$t('Please Confirm'),
            cancelVariant: 'outline-secondary',
            okVariant: 'success',
            okTitle: this.$t('Yes'),
            cancelTitle: this.$t('No'),
            centered: true,
          },
        )
        .then(value => {
          if (value === true) {
            if (this.selected.length > 0) {
              const obj = {
                dataSelected: this.selected,
              }
              this.show = true
              store
                .dispatch(`${STORE_MODULE_NAME}/import`, obj)
                .then(() => {
                  this.show = false

                  this.showToast(
                    'warning',
                    'top-right',
                    `${this.$t('IMPORT_DATA')}!`,
                    'PlusIcon',
                    this.$t('IMPORT_DATA'),
                  )
                })
                .catch(error => {
                  this.show = false

                  this.$toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                      title: this.$t('Error'),
                      icon: 'ErrorIcon',
                      variant: 'danger',
                      text: this.$t(error.response.data.message),
                    },
                  })
                })
            } else {
              this.showToast(
                'danger',
                'top-right',
                `${this.$t('NOT_SELECT_DATA')}!`,
                'XIcon',
                this.$t('NOT_SELECT_DATA'),
              )
            }
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
      // this.selected = this.respData
      // console.log(this.selected)
    },
    clearSelected() {
      // this.$refs.selectableTable.clearSelected()
      this.selected = []
    },
    onRowSelected(items) {
      this.selected = items
    },
    clearData() {
      this.inputUrl = ''
      this.currentPage = 1
      this.respData = []
      this.selected = []
      this.queriedItems = 0
      this.$refs.uploadFileJson.reset()
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
    },
    nextPage(page) {
      this.currentPage = page
    },
    getData() {
      this.show = true

      axios({
        method: 'get',
        url: this.inputUrl.trim(),
        responseType: 'stream',
      })
        .then(response => {
          const list = []
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index += 1) {
              // if (response.data[index].members_tel_confirm === 'true') {
              //   if (response.data[index].members_tel.length === 10) {
              list.push({
                members_tel: response.data[index].members_tel,
                members_email: response.data[index].members_email,
                members_username: response.data[index].members_username,
                members_passwd: response.data[index].members_passwd,
                members_name: response.data[index].members_name, // ยังไม่มี
                members_lastname: response.data[index].members_lastname,
              })
              //   }
              // }
            }
            this.respData = list
            this.queriedItems = list.length
            this.show = false
            this.showToast(
              'warning',
              'top-right',
              `${this.$t('GET_DATA')}!`,
              'PlusIcon',
              this.$t('GET_DATA'),
            )
          } else {
            this.show = false
            this.showToast(
              'warning',
              'top-right',
              `${this.$t('NOT_FOUND_DATA')}!`,
              'PlusIcon',
              this.$t('NOT_FOUND_DATA'),
            )
          }
        })
        .catch(err => {
          if (err) {
            console.log('ERROR MSG: ', err)
          }
          this.show = false
        })
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.b-col-custom {
  margin-top: 0.5rem;
}
</style>
